import { MenuIntemInterface } from './interfaces/menu-item.interface';
import { MenuCollapseInterface } from './interfaces/menu-collapse.interface';
import { MenuGroupInterface } from './interfaces/menu-group.interface';

export class AppNavigationModel {
	public model: any[];

	constructor() {
		this.model = [
			{
				id: 'applications',
				title: 'Applications',
				translate: 'Benefits System',
				type: 'group',
				icon: 'apps',
				children: [
					{
						id: 'home',
						title: 'Home',
						translate: 'home',
						type: 'item',
						url: '/main/home',
						icon: 'home',
					},
					{
						id: 'benefits-groups',
						title: 'Benefits groups',
						translate: 'benefits_groups',
						type: 'item',
						url: '/main/benefits-groups',
						icon: 'gpp_good',
					},
					{
						id: 'catalog',
						title: 'Catalogs',
						translate: 'catalogs',
						type: 'collapse',
						icon: 'workspaces_filled',
						children: [
							{
								id: 'sites',
								title: 'Sites',
								translate: 'sites',
								type: 'item',
								url: '/main/sites',
								icon: 'business',
							},
							{
								id: 'locations',
								title: 'Locations',
								translate: 'locations',
								type: 'item',
								url: '/main/locations',
								icon: 'location_on',
							},
							{
								id: 'pay-grades',
								title: 'Pay Grades',
								translate: 'pay_grades',
								type: 'item',
								url: '/main/paygrades',
								icon: 'account_balance',
							},
							{
								id: 'pay-grades',
								title: 'Pay Rate Types',
								translate: 'pay_rates_types',
								type: 'item',
								url: '/main/payratetypes',
								icon: 'account_balance_wallet',
							},
							{
								id: 'pay-grades-categories',
								title: 'Pay Rate Categories',
								translate: 'pay_grade_categories',
								type: 'item',
								url: '/main/pay-grades-categories',
								icon: 'account_balance_wallet',
							},
							/*{
								id: 'job-categories',
								title: 'Job Categories',
								translate: 'job_categories',
								type: 'item',
								url: '/main/jobcategories',
								icon: 'work_outline',
							},
							{
								id: 'employee-type',
								title: 'Employee Types',
								translate: 'employee_types',
								type: 'item',
								url: '/main/employeetypes',
								icon: 'person',
							},
							{
								id: 'external-links',
								title: 'External Links',
								translate: 'external_links',
								type: 'item',
								url: '/main/externallinks',
								icon: 'launch',
							},*/
						],
					},
					{
						id: 'users-&-roles',
						title: 'Users & Roles',
						translate: 'users_roles',
						type: 'collapse',
						icon: 'group',
						children: [
							{
								id: 'users',
								title: 'Users',
								translate: 'users',
								type: 'item',
								url: '/main/employees',
								icon: 'account_circle',
							},
							{
								id: 'roles',
								title: 'Roles',
								translate: 'roles',
								type: 'item',
								url: '/main/roles',
								icon: 'assignment_ind',
							},
						],
					},
					{
						id: 'configurations',
						title: 'Configurations',
						translate: 'settings',
						type: 'item',
						url: '/main/configurations',
						icon: 'settings',
					},
					{
						id: 'reports',
						title: 'Reports',
						translate: 'reports',
						type: 'item',
						url: '/main/reports',
						icon: 'pie_chart',
					},
					{
						id: 'about',
            			title: 'Abaout',
            			translate: 'about',
            			type: 'collapse',
            			icon: 'info_outline',
            			children: [
							{
								title: 'Contact',
								translate: 'contact',
								type: 'item',
								url: '/main/contact',
								icon: 'contact_mail_outlined',
							},
							{
								title: 'Last releases',
								translate: 'last_releases',
								type: 'item',
								url: '/main/lastreleases',
								icon: 'new_releases_outlined',
							},
							{
								title: 'Manual',
								translate: 'user_manual_download',
								type: 'item',
								function: () => { window.open('/assets/documents/benefits_user_manual.pdf', '_blank').focus(); },
								icon: 'file_download',
							},
						],
					},

				],
			},
		];
	}
}
